import { CONVERSATION_PRIORITY_ORDER } from 'shared/constants/messages';
import { ehEscaladaIA } from 'dashboard/helper/whuStageWait'; // [FORK CLINICA 19/10] DUVIDAS IA

export const findPendingMessageIndex = (chat, message) => {
  const { echo_id: tempMessageId } = message;
  return chat.messages.findIndex(
    m => m.id === message.id || m.id === tempMessageId
  );
};

export const filterByStatus = (chatStatus, filterStatus) =>
  filterStatus === 'all' ? true : chatStatus === filterStatus;

export const filterByInbox = (shouldFilter, inboxId, chatInboxId) => {
  const isOnInbox = Number(inboxId) === chatInboxId;
  return inboxId ? isOnInbox && shouldFilter : shouldFilter;
};

export const filterByTeam = (shouldFilter, teamId, chatTeamId) => {
  const isOnTeam = Number(teamId) === chatTeamId;
  return teamId ? isOnTeam && shouldFilter : shouldFilter;
};

export const filterByLabel = (shouldFilter, labels, chatLabels) => {
  const isOnLabel = labels.every(label => chatLabels.includes(label));
  return labels.length ? isOnLabel && shouldFilter : shouldFilter;
};
export const filterByUnattended = (
  shouldFilter,
  conversationType,
  firstReplyOn,
  waitingSince
) => {
  return conversationType === 'unattended'
    ? (!firstReplyOn || !!waitingSince) && shouldFilter
    : shouldFilter;
};

export const applyPageFilters = (conversation, filters) => {
  const { inboxId, status, labels = [], teamId, conversationType } = filters;
  const {
    status: chatStatus,
    inbox_id: chatInboxId,
    labels: chatLabels = [],
    meta = {},
    first_reply_created_at: firstReplyOn,
    waiting_since: waitingSince,
  } = conversation;
  const team = meta.team || {};
  const { id: chatTeamId } = team;

  let shouldFilter = filterByStatus(chatStatus, status);
  shouldFilter = filterByInbox(shouldFilter, inboxId, chatInboxId);
  shouldFilter = filterByTeam(shouldFilter, teamId, chatTeamId);
  shouldFilter = filterByLabel(shouldFilter, labels, chatLabels);
  shouldFilter = filterByUnattended(
    shouldFilter,
    conversationType,
    firstReplyOn,
    waitingSince
  );

  return shouldFilter;
};

/**
 * Filters conversations based on user role and permissions
 *
 * @param {Object} conversation - The conversation object to check permissions for
 * @param {string} role - The user's role (administrator, agent, etc.)
 * @param {Array<string>} permissions - List of permission strings the user has
 * @param {number|string} currentUserId - The ID of the current user
 * @param {Array<number>} myTeamIds - Ids dos times de que o usuario e MEMBRO
 * @returns {boolean} - Whether the user has permissions to access this conversation
 */
// [FORK CLINICA 27/08] O time de GERENCIA enxerga tudo.
// Casa pelo NOME normalizado, e nao pelo id: id de time e dado de instalacao e
// muda entre ambientes; o nome e o que a clinica usa. Aceita com e sem acento.
export const ehTimeDeGestao = nome =>
  String(nome ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase() === 'gestao';

export const applyRoleFilter = (
  conversation,
  role,
  permissions,
  currentUserId,
  myTeamIds = [],
  souGestor = false
) => {
  // Gerente ve a operacao inteira, como administrador. Sem isto, gerente que
  // nao e administrator no Chatwoot (papel customizado) fica com a fila VAZIA:
  // ele so pertence ao time Gestao, e nenhuma conversa de atendimento tem esse
  // time. Foi o que aconteceu com a Thamires em 27/08.
  if (souGestor) return true;

  // the role === "agent" check is typically not correct on it's own
  // the backend handles this by checking the custom_role_id at the user model
  // here however, the `getUserRole` returns "custom_role" if the id is present,
  // so we can check the role === "agent" directly
  if (['administrator', 'agent'].includes(role)) {
    return true;
  }

  // Check for full conversation management permission
  if (permissions.includes('conversation_manage')) {
    return true;
  }

  // [FORK CLINICA 19/10] DUVIDAS IA — conversation_duvidas_ia_manage e ADITIVA: a escalada da IA que nenhuma pessoa
  // assumiu aparece para quem tem a permissao, de QUALQUER time (espelho do soma_duvidas_ia do servidor). Sem isto o
  // servidor mandaria a conversa e o store a descartaria aqui: contador cheio, lista vazia.
  if (
    permissions.includes('conversation_duvidas_ia_manage') &&
    ehEscaladaIA(conversation)
  ) {
    return true;
  }

  const conversationAssignee = conversation.meta.assignee;
  const isUnassigned = !conversationAssignee;
  const isAssignedToUser = conversationAssignee?.id === currentUserId;

  // [FORK CLINICA 26/08] conversation_team_manage e ADITIVA (soma ao que o
  // agente ja via), entao entra como OR em cada ramo — nao como mais um ramo
  // exclusivo. Sem este espelho client-side a permissao nova nao apareceria:
  // o backend mandaria a conversa do time e o store a descartaria aqui.
  const conversationTeamId = conversation.meta?.team?.id;
  const isMyTeam =
    permissions.includes('conversation_team_manage') &&
    !!conversationTeamId &&
    myTeamIds.includes(conversationTeamId);

  // [FORK CLINICA 27/08] FILA SEM DONO E POR TIME, NAO DA CONTA INTEIRA.
  //
  // O original devolvia `isUnassigned` puro: QUALQUER conversa sem dono, de
  // QUALQUER time, aparecia para QUALQUER pessoa com esta permissao. Como o
  // papel customizado das atendentes a tem, todas viam a fila da conta toda.
  // A queixa da equipe em 27/08: "se eu sou da clinica, nao tenho interesse em
  // fechar um atendimento do Smart; unificou tudo e confunde pra caramba".
  //
  // A regra que vale agora, ditada pelo Arthur: "se o cliente parou no time da
  // clinica, so quem ve ele e o time da clinica — e o agente noturno, que faz
  // parte de praticamente todos os times". Repare que isso nao precisa de
  // excecao nenhuma para o plantao: ele enxerga tudo porque E membro de tudo.
  //
  // SEM TIME continua visivel para todos DE PROPOSITO: e o balde "Automatico",
  // onde o robo ainda conduz e o setor ainda nao foi decidido. Esconder por
  // time ali nao esconderia de um time — esconderia de TODOS, e a conversa
  // desapareceria (as 1.048 invisiveis ja pagaram essa conta aqui).
  if (permissions.includes('conversation_unassigned_manage')) {
    const semTime = !conversationTeamId;
    const filaQueMeCabe =
      isUnassigned && (semTime || myTeamIds.includes(conversationTeamId));
    return filaQueMeCabe || isAssignedToUser || isMyTeam;
  }

  // Check participating conversation management permission
  if (permissions.includes('conversation_participating_manage')) {
    return isAssignedToUser || isMyTeam;
  }

  return isMyTeam;
};

const SORT_OPTIONS = {
  last_activity_at_asc: ['sortOnLastActivityAt', 'asc'],
  last_activity_at_desc: ['sortOnLastActivityAt', 'desc'],
  created_at_asc: ['sortOnCreatedAt', 'asc'],
  created_at_desc: ['sortOnCreatedAt', 'desc'],
  priority_asc: ['sortOnPriority', 'asc'],
  priority_desc: ['sortOnPriority', 'desc'],
  waiting_since_asc: ['sortOnWaitingSince', 'asc'],
  waiting_since_desc: ['sortOnWaitingSince', 'desc'],
  priority_desc_created_at_asc: ['sortOnPriorityCreatedAt', 'desc'],
};
const sortAscending = (valueA, valueB) => valueA - valueB;
const sortDescending = (valueA, valueB) => valueB - valueA;

const getSortOrderFunction = sortOrder =>
  sortOrder === 'asc' ? sortAscending : sortDescending;

const sortConfig = {
  sortOnLastActivityAt: (a, b, sortDirection) =>
    getSortOrderFunction(sortDirection)(a.last_activity_at, b.last_activity_at),

  sortOnCreatedAt: (a, b, sortDirection) =>
    getSortOrderFunction(sortDirection)(a.created_at, b.created_at),

  sortOnPriority: (a, b, sortDirection) => {
    const DEFAULT_FOR_NULL = sortDirection === 'asc' ? 5 : 0;

    const p1 = CONVERSATION_PRIORITY_ORDER[a.priority] || DEFAULT_FOR_NULL;
    const p2 = CONVERSATION_PRIORITY_ORDER[b.priority] || DEFAULT_FOR_NULL;

    return getSortOrderFunction(sortDirection)(p1, p2);
  },

  sortOnPriorityCreatedAt: (a, b) => {
    const DEFAULT_FOR_NULL = 0;
    const p1 = CONVERSATION_PRIORITY_ORDER[a.priority] || DEFAULT_FOR_NULL;
    const p2 = CONVERSATION_PRIORITY_ORDER[b.priority] || DEFAULT_FOR_NULL;
    if (p1 !== p2) return p2 - p1;
    return a.created_at - b.created_at;
  },

  sortOnWaitingSince: (a, b, sortDirection) => {
    const sortFunc = getSortOrderFunction(sortDirection);
    if (!a.waiting_since || !b.waiting_since) {
      if (!a.waiting_since && !b.waiting_since) {
        return sortFunc(a.created_at, b.created_at);
      }
      return sortFunc(a.waiting_since ? 0 : 1, b.waiting_since ? 0 : 1);
    }

    return sortFunc(a.waiting_since, b.waiting_since);
  },
};

export const sortComparator = (a, b, sortKey) => {
  const [sortMethod, sortDirection] =
    SORT_OPTIONS[sortKey] || SORT_OPTIONS.last_activity_at_desc;
  return sortConfig[sortMethod](a, b, sortDirection);
};
